module.exports = __webpack_public_path__ + "static/media/explore.a59dcff4.ico";